export enum HistoricoAcaoEnum {
    Adicionado = 1,
    AdicionadoDescription = 'Adicionado',
    Modificado = 2,
    ModificadoDescription = 'Modificado',
    Excluido = 3,
    ExcluidoDescription = 'Excluído'
}
